import { expose } from 'comlink';
  var exports = {};
  "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

require("regenerator-runtime/runtime");

var _core = require("@buildwithflux/core");

var _ngspiceSimulator = require("@buildwithflux/ngspice-simulator");

var _shared = require("@buildwithflux/shared");

var _compressJson = require("compress-json");

var _graphology = require("graphology");

var _graphology2 = _interopRequireDefault(_graphology);

var _graphologyComponents = require("graphology-components");

var _immer = require("immer");

var _lodash = require("lodash");

var _BehaviorManager = require("./BehaviorManager");

var _helpers = require("./helpers");

var _SimulationEventEmitter = require("./SimulationEventEmitter");

var _SimulationModelAdapter = require("./SimulationModelAdapter");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var __defProp = Object.defineProperty;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __publicField = function __publicField(obj, key, value) {
  __defNormalProp(obj, _typeof(key) !== "symbol" ? key + "" : key, value);

  return value;
};

if ((0, _shared.isWebWorker)()) {
  (0, _immer.enablePatches)();
}

function uninitialized() {
  return {
    type: "uninitialized",
    runtimeData: {}
  };
}

function waitingForRuntimeData(spiceFactory, runtimeData) {
  return {
    type: "waitingForRuntimeData",
    runtimeData: runtimeData || {},
    spiceFactory: spiceFactory
  };
}

function idle(spiceFactory, behaviorMgr, runtimeData) {
  return {
    type: "idle",
    spiceFactory: spiceFactory,
    simulationModelMapper: new _SimulationModelAdapter.SimulationModelMapper(),
    simulator: new _ngspiceSimulator.SteppedSpiceSimulator(spiceFactory, runtimeData.documentState.name),
    behaviorMgr: behaviorMgr,
    deviceToElementMap: /* @__PURE__ */new Map(),
    elementUidToDesignatorMap: /* @__PURE__ */new Map(),
    runtimeData: runtimeData
  };
}

function running(idleState) {
  return _objectSpread(_objectSpread({}, idleState), {}, {
    type: "running"
  });
}

function error(runningState, why) {
  return _objectSpread(_objectSpread({}, runningState), {}, {
    type: "error",
    why: why
  });
}

var UserCodeRuntime = /*#__PURE__*/function () {
  function UserCodeRuntime() {
    _classCallCheck(this, UserCodeRuntime);

    __publicField(this, "ucrtState", uninitialized());

    __publicField(this, "stepTimeout");

    __publicField(this, "restartTimeout");

    __publicField(this, "eventEmitter");

    __publicField(this, "changeSymbolForElement");

    __publicField(this, "enqueueSnackbar");

    __publicField(this, "eventQueue", []);

    __publicField(this, "delay", 300);

    __publicField(this, "timeStepSeconds", 1e-3);

    __publicField(this, "maxSteps", 1e5);

    __publicField(this, "nets", []);

    __publicField(this, "elements", {});

    __publicField(this, "debug", !(0, _shared.isProductionEnvironment)());
  }

  _createClass(UserCodeRuntime, [{
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var spiceFactory;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _ngspiceSimulator.createNgSpiceInstanceFactory)(this.debug);

              case 2:
                spiceFactory = _context.sent;
                this.ucrtState = waitingForRuntimeData(spiceFactory);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function initialize() {
        return _initialize.apply(this, arguments);
      }

      return initialize;
    }() /////// Methods for testing

  }, {
    key: "getState",
    value: function () {
      var _getState = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", this.ucrtState);

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getState() {
        return _getState.apply(this, arguments);
      }

      return getState;
    }()
  }, {
    key: "getEventEmitter",
    value: function () {
      var _getEventEmitter = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", this.eventEmitter);

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getEventEmitter() {
        return _getEventEmitter.apply(this, arguments);
      }

      return getEventEmitter;
    }()
  }, {
    key: "getTimeStep",
    value: function () {
      var _getTimeStep = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", this.timeStepSeconds);

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getTimeStep() {
        return _getTimeStep.apply(this, arguments);
      }

      return getTimeStep;
    }()
  }, {
    key: "getSimulatorSpeed",
    value: function () {
      var _getSimulatorSpeed = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", 1e4 / this.delay - 35);

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getSimulatorSpeed() {
        return _getSimulatorSpeed.apply(this, arguments);
      }

      return getSimulatorSpeed;
    }() /////// End of methods for testing
    /////// Start of original simulator methods

  }, {
    key: "setCurrentUser",
    value: function () {
      var _setCurrentUser = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(currentUser) {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.patchRuntimeData({
                  currentUser: currentUser
                });

              case 2:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function setCurrentUser(_x) {
        return _setCurrentUser.apply(this, arguments);
      }

      return setCurrentUser;
    }()
  }, {
    key: "setChangeSymbolForElement",
    value: function () {
      var _setChangeSymbolForElement = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(changeSymbolForElement) {
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                this.changeSymbolForElement = changeSymbolForElement;

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function setChangeSymbolForElement(_x2) {
        return _setChangeSymbolForElement.apply(this, arguments);
      }

      return setChangeSymbolForElement;
    }()
  }, {
    key: "setSnackbarProvider",
    value: function () {
      var _setSnackbarProvider = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(enqueueSnackbar) {
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                this.enqueueSnackbar = enqueueSnackbar;

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function setSnackbarProvider(_x3) {
        return _setSnackbarProvider.apply(this, arguments);
      }

      return setSnackbarProvider;
    }()
  }, {
    key: "setSimulationEventEmitter",
    value: function () {
      var _setSimulationEventEmitter = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(simulationEventEmitter) {
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                this.eventEmitter = simulationEventEmitter;

              case 1:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function setSimulationEventEmitter(_x4) {
        return _setSimulationEventEmitter.apply(this, arguments);
      }

      return setSimulationEventEmitter;
    }()
  }, {
    key: "setActionDispatcher",
    value: function () {
      var _setActionDispatcher = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(actionDispatcher) {
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this.patchRuntimeData({
                  actionDispatcher: actionDispatcher
                });

              case 2:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function setActionDispatcher(_x5) {
        return _setActionDispatcher.apply(this, arguments);
      }

      return setActionDispatcher;
    }()
  }, {
    key: "setProjectExpressionContext",
    value: function () {
      var _setProjectExpressionContext = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(projectExpressionContext) {
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return this.patchRuntimeData({
                  projectExpressionContext: projectExpressionContext
                });

              case 2:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function setProjectExpressionContext(_x6) {
        return _setProjectExpressionContext.apply(this, arguments);
      }

      return setProjectExpressionContext;
    }()
  }, {
    key: "applyPatches",
    value: function () {
      var _applyPatches2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(patch) {
        var netChanges, elementPropertyChanges, shouldRestart;
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                if (!(this.ucrtState.runtimeData.documentState === void 0)) {
                  _context12.next = 2;
                  break;
                }

                return _context12.abrupt("return");

              case 2:
                netChanges = (0, _core.getMatchingCollectionChangesFromPatch)(patch, "nets").nets;
                elementPropertyChanges = (0, _core.getMatchingCollectionChangesFromPatch)(patch, "elements", "properties").elements;

                if (this.ucrtState.type === "running" || this.ucrtState.type === "idle") {
                  this.ucrtState.behaviorMgr.triggerUpdatesFromPatch(patch);
                  this.processIntraloopEvents(this.eventQueue);
                }

                this.ucrtState.runtimeData.documentState = (0, _immer.applyPatches)(this.ucrtState.runtimeData.documentState, patch.forward);
                shouldRestart = netChanges !== void 0 || elementPropertyChanges !== void 0;

                if (shouldRestart) {
                  if (this.debug) console.debug("Restarting simulation due to patch");
                  this.reset();
                }

              case 8:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function applyPatches(_x7) {
        return _applyPatches2.apply(this, arguments);
      }

      return applyPatches;
    }()
  }, {
    key: "setConfigs",
    value: function () {
      var _setConfigs = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(configs) {
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13);
      }));

      function setConfigs(_x8) {
        return _setConfigs.apply(this, arguments);
      }

      return setConfigs;
    }()
  }, {
    key: "setStepSize",
    value: function () {
      var _setStepSize = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(stepSize) {
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                this.timeStepSeconds = stepSize;
                _context14.t0 = this.ucrtState.type;
                _context14.next = _context14.t0 === "idle" ? 4 : _context14.t0 === "running" ? 6 : 9;
                break;

              case 4:
                this.ucrtState.simulator.configure({
                  timeStepSeconds: stepSize
                });
                return _context14.abrupt("break", 9);

              case 6:
                this.ucrtState.simulator.configure({
                  timeStepSeconds: stepSize
                });
                this.reset();
                return _context14.abrupt("break", 9);

              case 9:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function setStepSize(_x9) {
        return _setStepSize.apply(this, arguments);
      }

      return setStepSize;
    }()
  }, {
    key: "setSimulatorSpeed",
    value: function () {
      var _setSimulatorSpeed = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(speed) {
        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                this.delay = 1e4 / (speed + 35);

              case 1:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function setSimulatorSpeed(_x10) {
        return _setSimulatorSpeed.apply(this, arguments);
      }

      return setSimulatorSpeed;
    }() // NOTE: we compress here to save bandwidth and fit under the 10MB firebase
    // response limit. In testing, a 16MB document's worth of data was shrunk
    // down to 2.3MB. This should be even better than lz-string.
    // See https://github.com/beenotung/compress-json/issues/4#issuecomment-909429464
    // See getSimInitDataCompressed for frontend.

  }, {
    key: "setFlattenedSubjectsCompressed",
    value: function () {
      var _setFlattenedSubjectsCompressed = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16(flattenedSubjectsCompressed) {
        return regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                return _context16.abrupt("return", this.setFlattenedSubjects((0, _compressJson.decompress)(flattenedSubjectsCompressed)));

              case 1:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function setFlattenedSubjectsCompressed(_x11) {
        return _setFlattenedSubjectsCompressed.apply(this, arguments);
      }

      return setFlattenedSubjectsCompressed;
    }()
  }, {
    key: "setFlattenedSubjects",
    value: function () {
      var _setFlattenedSubjects = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17(flattenedSubjects) {
        var clonedSubjects;
        return regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                clonedSubjects = (0, _lodash.cloneDeep)(flattenedSubjects);
                _context17.next = 3;
                return this.patchRuntimeData({
                  flattenedSubjects: clonedSubjects
                });

              case 3:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function setFlattenedSubjects(_x12) {
        return _setFlattenedSubjects.apply(this, arguments);
      }

      return setFlattenedSubjects;
    }()
    /**
     * Set the document that we're currently executing the runtime for.  If the runtime is currently executing,
     * then this will have the effect of restarting the runtime.  If it is not currently executing, this will
     * start the runtime loop.  The simulator is not guaranteed to start after this call - if the provided data
     * does not describe a complete circuit, the runtime will start but simulation will not.
     */

  }, {
    key: "setDocumentData",
    value: function () {
      var _setDocumentData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18(documentData) {
        return regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.t0 = this.ucrtState.type;
                _context18.next = _context18.t0 === "uninitialized" ? 3 : _context18.t0 === "waitingForRuntimeData" ? 3 : _context18.t0 === "idle" ? 6 : _context18.t0 === "running" ? 10 : _context18.t0 === "error" ? 14 : 18;
                break;

              case 3:
                _context18.next = 5;
                return this.patchRuntimeData({
                  documentState: documentData
                });

              case 5:
                return _context18.abrupt("return", _context18.sent);

              case 6:
                this.destroyUcrtState();
                _context18.next = 9;
                return this.setDocumentData(documentData);

              case 9:
                return _context18.abrupt("return", _context18.sent);

              case 10:
                this.destroyUcrtState();
                _context18.next = 13;
                return this.setDocumentData(documentData);

              case 13:
                return _context18.abrupt("return", _context18.sent);

              case 14:
                this.destroyUcrtState();
                _context18.next = 17;
                return this.setDocumentData(documentData);

              case 17:
                return _context18.abrupt("return", _context18.sent);

              case 18:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function setDocumentData(_x13) {
        return _setDocumentData.apply(this, arguments);
      }

      return setDocumentData;
    }()
  }, {
    key: "onControlsChanged",
    value: function () {
      var _onControlsChanged = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19(elementUid, controlConfig, value) {
        return regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                if (!(this.ucrtState.type !== "idle" && this.ucrtState.type !== "running")) {
                  _context19.next = 2;
                  break;
                }

                return _context19.abrupt("return");

              case 2:
                this.ucrtState.behaviorMgr.updateControl(elementUid, controlConfig, value);

              case 3:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));

      function onControlsChanged(_x14, _x15, _x16) {
        return _onControlsChanged.apply(this, arguments);
      }

      return onControlsChanged;
    }()
  }, {
    key: "dispose",
    value: function () {
      var _dispose = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20() {
        return regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20);
      }));

      function dispose() {
        return _dispose.apply(this, arguments);
      }

      return dispose;
    }() /////// End of original simulator methods

  }, {
    key: "reset",
    value: function () {
      var _reset = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee21() {
        var _this = this;

        return regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                clearTimeout(this.restartTimeout);
                this.restartTimeout = setTimeout(function () {
                  if (_this.ucrtState.type === "running" || _this.ucrtState.type === "idle" || _this.ucrtState.type === "error") {
                    _this.stop();

                    _this.start();
                  }
                }, 1e3);

              case 2:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));

      function reset() {
        return _reset.apply(this, arguments);
      }

      return reset;
    }()
  }, {
    key: "start",
    value: function start() {
      (0, _helpers.assertState)("idle", this.ucrtState);
      this.startRuntimeLoop();
    }
  }, {
    key: "stop",
    value: function stop() {
      clearTimeout(this.stepTimeout);
      this.stepTimeout = void 0;

      if (this.ucrtState.type === "running" || this.ucrtState.type === "error") {
        this.ucrtState.simulator.clear();
        this.ucrtState = idle(this.ucrtState.spiceFactory, new _BehaviorManager.BehaviorManager(), this.ucrtState.runtimeData);
      }
    }
  }, {
    key: "patchRuntimeData",
    value: function () {
      var _patchRuntimeData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee22(runtimeData) {
        var maybeRuntimeData;
        return regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                _context22.t0 = this.ucrtState.type;
                _context22.next = _context22.t0 === "idle" ? 3 : _context22.t0 === "running" ? 3 : _context22.t0 === "error" ? 4 : _context22.t0 === "waitingForRuntimeData" ? 5 : 11;
                break;

              case 3:
                return _context22.abrupt("return");

              case 4:
                return _context22.abrupt("return");

              case 5:
                this.ucrtState.runtimeData = _objectSpread(_objectSpread({}, this.ucrtState.runtimeData), runtimeData);
                maybeRuntimeData = (0, _helpers.validatePartialRuntimeData)(this.ucrtState.runtimeData);

                if (maybeRuntimeData) {
                  _context22.next = 9;
                  break;
                }

                return _context22.abrupt("return");

              case 9:
                this.ucrtState = idle(this.ucrtState.spiceFactory, new _BehaviorManager.BehaviorManager(), maybeRuntimeData);
                return _context22.abrupt("return", this.startRuntimeLoop());

              case 11:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this);
      }));

      function patchRuntimeData(_x17) {
        return _patchRuntimeData.apply(this, arguments);
      }

      return patchRuntimeData;
    }()
  }, {
    key: "generateElementsAndNets",
    value: function generateElementsAndNets() {
      (0, _helpers.assertState)("idle", this.ucrtState);
      var elementsMap = (0, _lodash.mapValues)(this.ucrtState.runtimeData.flattenedSubjects.elements, "element");

      for (var _i = 0, _Object$keys = Object.keys(elementsMap); _i < _Object$keys.length; _i++) {
        var uid = _Object$keys[_i];
        if (uid.includes(_core.simulatorNodeDelimiter)) continue;

        if (!this.ucrtState.runtimeData.documentState.elements[uid]) {
          delete elementsMap[uid];
        }
      }

      var mergedElements = (0, _lodash.merge)(elementsMap, this.ucrtState.runtimeData.documentState.elements);

      for (var _i2 = 0, _Object$keys2 = Object.keys(this.ucrtState.runtimeData.flattenedSubjects.vertices); _i2 < _Object$keys2.length; _i2++) {
        var _uid = _Object$keys2[_i2];
        if (_uid.includes(_core.simulatorNodeDelimiter)) continue;

        if (!this.ucrtState.runtimeData.documentState.routeVertices[_uid]) {
          delete this.ucrtState.runtimeData.flattenedSubjects.vertices[_uid];
        }
      }

      var mergedVertices = (0, _lodash.merge)(this.ucrtState.runtimeData.flattenedSubjects.vertices, this.ucrtState.runtimeData.documentState.routeVertices);
      this.nets = this.generateNets(mergedElements, mergedVertices);
      this.elements = elementsMap;
    }
    /** The logic in generateNets should mirror the logic in netMapping.generateNetInstances()
     * TODO seems like it'd be a good idea to consolidate and just call the netMapping version,
     * with appropriate flags/changes if necessary?
     */

  }, {
    key: "generateNets",
    value: function generateNets(elements, vertices) {
      var _a, _b;

      (0, _helpers.assertState)("idle", this.ucrtState);
      var delimiter = _core.simulatorNodeDelimiter;
      var graph = new _graphology2.default({
        multi: false,
        type: "undirected"
      });
      var terminalElementIds = {};

      for (var _i3 = 0, _Object$values = Object.values(vertices); _i3 < _Object$values.length; _i3++) {
        var vertex = _Object$values[_i3];

        for (var _i4 = 0, _Object$keys3 = Object.keys(vertex.connectedVertices); _i4 < _Object$keys3.length; _i4++) {
          var other = _Object$keys3[_i4];
          graph.mergeEdge(vertex.id, other);
        }

        if (!vertex.terminal) continue;
        var elementUid = vertex.terminal.element_uid;
        var element = elements[elementUid];
        if (!element) continue;
        var terminalUid = (0, _core.createTUID)(vertex.terminal, delimiter);
        graph.mergeEdge(vertex.id, terminalUid);

        if (vertex.terminal.terminal_uid !== _core.GENESIS_TERMINAL_TERMINAL_UID) {
          terminalElementIds[terminalUid] = elementUid;
        }

        var placeholderTerminalId = "SUBMODULE_PORTAL_PLACEHOLDER";

        var _splitMultipartUID = (0, _core.splitMultipartUID)(vertex.terminal.element_uid, delimiter),
            _splitMultipartUID2 = _slicedToArray(_splitMultipartUID, 1),
            parentUid = _splitMultipartUID2[0];

        var portalId = void 0;

        if (element && _core.Element.isPortal(element)) {
          if (parentUid) {
            var portalElementId = (0, _core.createTUID)([parentUid, (_a = element.label) != null ? _a : ""], delimiter);
            portalId = (0, _core.createTUID)([portalElementId, placeholderTerminalId], delimiter);
          } else {
            portalId = (0, _core.createTUID)(["", (_b = element.label) != null ? _b : ""], delimiter);
          }
        } else if (element && _core.Element.isGroundElement(element)) {
          if (parentUid) {
            var _portalElementId = (0, _core.createTUID)([parentUid, _core.GROUND_TERMINAL_UID], delimiter);

            portalId = (0, _core.createTUID)([_portalElementId, placeholderTerminalId], delimiter);
          } else {
            portalId = _core.GROUND_TERMINAL_UID;
          }
        }

        if (portalId) {
          graph.mergeEdge(terminalUid, portalId);
        }
      }

      var subGraphs = (0, _graphologyComponents.connectedComponents)(graph);
      var nets = [];

      var _iterator = _createForOfIteratorHelper(subGraphs),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var nodeIds = _step.value;
          var terminals = Object.fromEntries(nodeIds.filter(function (id) {
            return id in terminalElementIds;
          }).map(function (id) {
            return [id, terminalElementIds[id]];
          }));
          var net = new _core.Net(terminals, {
            delimiter: delimiter
          });

          if (net.terminals.size > 0) {
            nets.push(net);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return nets;
    }
  }, {
    key: "startRuntimeLoop",
    value: function startRuntimeLoop() {
      var _this2 = this;

      var _a, _b, _c, _d;

      (0, _helpers.assertState)("idle", this.ucrtState);

      if (this.debug) {
        this.ucrtState.simulator.enableDebugOutput();
      }

      this.ucrtState.simulator.configure({
        timeStepSeconds: this.timeStepSeconds,
        simulationEndTimeSeconds: this.computeEndTimeSeconds()
      });
      this.generateElementsAndNets();
      this.ucrtState.simulationModelMapper.resetCounters();
      var elementInitEvents = [];
      var terminalUidToNodeNameMap = /* @__PURE__ */new Map();
      var elementsMissingModels = [];

      var _loop = function _loop() {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i5], 2),
            elementUid = _Object$entries$_i[0],
            originalElement = _Object$entries$_i[1];

        if (_core.Element.isGroundElement(originalElement) || _core.Element.isPortal(originalElement)) return "continue";

        var element = _objectSpread(_objectSpread({}, originalElement), {}, {
          uid: elementUid
        });

        var behavior = _this2.ucrtState.behaviorMgr.addBehavior(element, _this2.ucrtState.runtimeData, _this2.eventQueue);

        var maybeSimulationModel = behavior.getModel();

        if (!maybeSimulationModel) {
          if (element.part_version_data_cache.name === "RouteBranchPoint" || element.part_version_data_cache.name === "Terminal") {
            return "continue";
          }

          if (!element.part_version_data_cache.behaviour_is_derived) {
            elementsMissingModels.push(elementUid);
          }

          return "continue";
        }

        var mappedModel = _this2.ucrtState.simulationModelMapper.mapModel(element, maybeSimulationModel);

        if (!mappedModel) {
          if (_this2.debug) {
            console.debug("Failed to map model ".concat(maybeSimulationModel.type, " for element ").concat(elementUid));
          }

          elementsMissingModels.push(elementUid);
          return "continue";
        }

        _this2.ucrtState.simulator.updateCircuit(function (circuit) {
          (0, _ngspiceSimulator.addInstance)(circuit, [mappedModel.instance]);
        }).unwrap();

        _this2.ucrtState.deviceToElementMap.set(mappedModel.instance.designator, mappedModel);

        _this2.ucrtState.elementUidToDesignatorMap.set(elementUid, mappedModel.instance.designator);

        var _iterator2 = _createForOfIteratorHelper(mappedModel.terminalMapping),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _step2$value = _slicedToArray(_step2.value, 2),
                nodeName = _step2$value[0],
                terminalUid = _step2$value[1];

            terminalUidToNodeNameMap.set(terminalUid, nodeName);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      };

      for (var _i5 = 0, _Object$entries = Object.entries(this.elements); _i5 < _Object$entries.length; _i5++) {
        var _ret = _loop();

        if (_ret === "continue") continue;
      }

      var _this$mapNets = this.mapNets(terminalUidToNodeNameMap, elementsMissingModels),
          missingModelConnections = _this$mapNets.missingModelConnections;

      (_a = this.eventEmitter) == null ? void 0 : _a.emit(_SimulationEventEmitter.SimulationEventKey.MissingModels, elementsMissingModels);

      if (this.ucrtState.simulator.simulatorCanStart()) {
        this.ucrtState = running(this.ucrtState);
        (_b = this.eventEmitter) == null ? void 0 : _b.emit(_SimulationEventEmitter.SimulationEventKey.UserCodeError, void 0);
        (_c = this.eventEmitter) == null ? void 0 : _c.emit(_SimulationEventEmitter.SimulationEventKey.InvalidCircuit, []);
        this.processIntraloopEvents(elementInitEvents);
        this.startSimulatorLoop();
        return;
      }

      var simState = this.ucrtState.simulator.getState();

      if (simState.type === "invalidCircuit") {
        var missingModelConnectionsSet = new Set(missingModelConnections.map(_ngspiceSimulator.descriptorToPort));
        var missingConnections = simState.missingConnections.filter(function (descriptor) {
          return !missingModelConnectionsSet.has((0, _ngspiceSimulator.descriptorToPort)(descriptor));
        });
        var userReadableMissingConnections = (0, _core.filterNotNull)(missingConnections.map(function (deviceNodeDescriptor) {
          return _this2.userReadableDeviceNodeDescriptor(deviceNodeDescriptor);
        }, this));

        if (this.debug) {
          console.debug("Stopping simulation due to invalid circuit", {
            missingConnections: missingConnections,
            userReadableMissingConnections: userReadableMissingConnections
          });
        }

        (_d = this.eventEmitter) == null ? void 0 : _d.emit(_SimulationEventEmitter.SimulationEventKey.InvalidCircuit, userReadableMissingConnections);
      }
    }
  }, {
    key: "userReadableDeviceNodeDescriptor",
    value: function userReadableDeviceNodeDescriptor(deviceNodeDescriptor) {
      var _a, _b;

      if (this.ucrtState.type === "uninitialized" || this.ucrtState.type === "waitingForRuntimeData") return;
      var designator = deviceNodeDescriptor.designator,
          nodeName = deviceNodeDescriptor.nodeName;
      var mappedDevice = this.ucrtState.deviceToElementMap.get(designator);
      if (!mappedDevice) return;
      var element = this.elements[mappedDevice.elementUid];
      if (!element) return;
      var elementLabel = (_a = element.label) != null ? _a : element.part_version_data_cache.name;
      var terminalUid = mappedDevice.terminalMapping.get(nodeName);
      if (!terminalUid) return;
      var terminal = element.part_version_data_cache.terminals[terminalUid];
      if (!terminal) return;
      var terminalLabel = (_b = terminal.name) != null ? _b : terminal.pin_number;
      if (!terminalLabel) return;
      return {
        elementUid: mappedDevice.elementUid,
        label: "".concat(elementLabel, ":").concat(terminalLabel)
      };
    }
  }, {
    key: "mapNets",
    value: function mapNets(terminalUidToNodeNameMap, elementsMissingModels) {
      var _this3 = this;

      (0, _helpers.assertState)("idle", this.ucrtState);
      var missingModelConnections = [];

      var _iterator3 = _createForOfIteratorHelper(this.nets),
          _step3;

      try {
        var _loop2 = function _loop2() {
          var net = _step3.value;
          var deviceDescriptors = [];
          var hasMissingModel = false;

          var _iterator4 = _createForOfIteratorHelper(net.terminals),
              _step4;

          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var terminalUid = _step4.value;
              var uidParts = terminalUid.split(_core.simulatorNodeDelimiter);
              var terminalId = uidParts.pop();
              var elementUid = uidParts.join(_core.simulatorNodeDelimiter);

              if (elementsMissingModels.includes(elementUid)) {
                hasMissingModel = true;
                continue;
              }

              if (!terminalId) {
                if (_this3.debug) console.error("Terminal ".concat(terminalUid, " has no terminalId"));
                continue;
              }

              var element = _this3.elements[elementUid];

              if (!element) {
                if (_this3.debug) console.error("Terminal ".concat(terminalUid, " has no element ").concat(elementUid));
                continue;
              }

              var designator = _this3.ucrtState.elementUidToDesignatorMap.get(elementUid);

              if (!designator) {
                if (_this3.debug && !element.part_version_data_cache.behaviour_is_derived && !_core.Element.isGroundElement(element) && !_core.Element.isPortal(element)) {
                  console.error("Element ".concat(elementUid, " of type ").concat(element.part_version_data_cache.name, " has no designator"));
                }

                continue;
              }

              var nodeName = terminalUidToNodeNameMap.get(terminalId);

              if (!nodeName) {
                if (_this3.debug) console.error("Terminal ".concat(terminalId, " has no nodeName"));
                continue;
              }

              var deviceDescriptor = {
                designator: designator,
                nodeName: nodeName
              };
              deviceDescriptors.push(deviceDescriptor);
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }

          if (hasMissingModel) {
            missingModelConnections.push.apply(missingModelConnections, deviceDescriptors);
          }

          var devicePorts = deviceDescriptors.map(_ngspiceSimulator.descriptorToPort);

          if (net.isGroundNet()) {
            _this3.ucrtState.simulator.updateCircuit(function (circuit) {
              var _iterator5 = _createForOfIteratorHelper(devicePorts),
                  _step5;

              try {
                for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                  var devicePort = _step5.value;
                  (0, _ngspiceSimulator.groundDeviceNode)(circuit, devicePort);
                }
              } catch (err) {
                _iterator5.e(err);
              } finally {
                _iterator5.f();
              }
            }).unwrap();
          } else {
            if (devicePorts.length < 2) {
              if (_this3.debug) console.debug("Net has fewer than 2 device ports connected, skipping connection");
              return "continue";
            }

            var referenceDevicePort = devicePorts[0];
            if (!referenceDevicePort) throw new Error("No referenceDevicePort, this was checked");

            _this3.ucrtState.simulator.updateCircuit(function (circuit) {
              var _iterator6 = _createForOfIteratorHelper(devicePorts.slice(1)),
                  _step6;

              try {
                for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                  var devicePort = _step6.value;
                  (0, _ngspiceSimulator.connectDevices)(circuit, referenceDevicePort, devicePort);
                }
              } catch (err) {
                _iterator6.e(err);
              } finally {
                _iterator6.f();
              }
            }).unwrap();
          }
        };

        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _ret2 = _loop2();

          if (_ret2 === "continue") continue;
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      return {
        missingModelConnections: missingModelConnections
      };
    }
  }, {
    key: "startSimulatorLoop",
    value: function startSimulatorLoop() {
      var _this4 = this;

      (0, _helpers.assertState)("running", this.ucrtState);

      if (this.stepTimeout) {
        clearTimeout(this.stepTimeout);
      }

      this.stepTimeout = setTimeout(function () {
        _this4.performSingleRuntimeLoopIteration();

        if (_this4.ucrtState.type === "running") {
          _this4.startSimulatorLoop();
        }
      }, this.delay);
    }
  }, {
    key: "toErrorState",
    value: function toErrorState(why) {
      (0, _helpers.assertState)("running", this.ucrtState);
      clearTimeout(this.stepTimeout);
      this.stepTimeout = void 0;
      this.ucrtState = error(this.ucrtState, why);
      if (this.debug) console.error("simulator stopped:", why);
    }
  }, {
    key: "performSingleRuntimeLoopIteration",
    value: function performSingleRuntimeLoopIteration() {
      (0, _helpers.assertState)("running", this.ucrtState);
      this.ucrtState.behaviorMgr.triggerBeforeStep({
        step: this.ucrtState.simulator.getCurrentStep(),
        time_since_simulation_start: (0, _helpers.intoMilliseconds)(this.ucrtState.simulator.getSimulationTime()),
        time_since_last_step: (0, _helpers.intoMilliseconds)(this.timeStepSeconds),
        // TODO: Get the actual time since last step
        step_size_time: (0, _helpers.intoMilliseconds)(this.timeStepSeconds)
      });
      this.processIntraloopEvents(this.eventQueue);
      if (this.ucrtState.type !== "running") return;
      var nextFrame = this.ucrtState.simulator.step();

      if (!nextFrame.ok) {
        if (this.ucrtState.simulator.isOutOfSteps()) {
          if (this.debug) console.debug("simulator out of steps, restarting");
          this.reset();
          return;
        }

        if (nextFrame.why.startsWith("Error: ngspice.dll cannot recover")) {
          if (this.debug) console.debug("simulator out of memory, lowering end time and restarting");
          this.maxSteps /= 2;
          this.ucrtState.simulator.configure({
            simulationEndTimeSeconds: this.computeEndTimeSeconds()
          });
          this.reset();
          return;
        }

        if (this.debug) console.error("failed to step simulator: ".concat(nextFrame.why));
        this.toErrorState(nextFrame.why);
        return;
      }

      var _iterator7 = _createForOfIteratorHelper(nextFrame.value),
          _step7;

      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var frame = _step7.value;
          var eventContext = {
            step: frame.frameNumber,
            time_since_simulation_start: (0, _helpers.intoMilliseconds)(frame.frameTimeSeconds),
            time_since_last_step: (0, _helpers.intoMilliseconds)(this.timeStepSeconds),
            // TODO: Get the actual time since last step
            step_size_time: (0, _helpers.intoMilliseconds)(this.timeStepSeconds)
          };
          var parentElementMeasurements = {};

          for (var _i6 = 0, _Object$keys4 = Object.keys(frame.deviceMeasurements); _i6 < _Object$keys4.length; _i6++) {
            var designator = _Object$keys4[_i6];
            var mappedModel = this.ucrtState.deviceToElementMap.get(designator);

            if (!mappedModel) {
              throw new Error("invariant violated: designator ".concat(designator, " did not map to an element"));
            }

            var terminalMeasurements = this.ucrtState.simulationModelMapper.mapMeasurements(mappedModel, frame);

            if (mappedModel.elementUid.includes(_core.simulatorNodeDelimiter)) {
              var parentUid = mappedModel.elementUid.split(_core.simulatorNodeDelimiter)[0];

              if (!parentUid) {
                throw new Error("invariant violated: parentUid was empty for ".concat(mappedModel.elementUid));
              }

              if (!parentElementMeasurements[parentUid]) {
                parentElementMeasurements[parentUid] = {};
              }

              parentElementMeasurements[parentUid][mappedModel.elementUid] = terminalMeasurements;
            }

            var behavior = this.ucrtState.behaviorMgr.getBehavior(mappedModel.elementUid);

            if (!behavior) {
              throw new Error("invariant violated: behavior for element ".concat(mappedModel.elementUid, " was not found in behavior manager"));
            }

            behavior.afterStepFinished(eventContext, terminalMeasurements);
          }

          this.handleParentElementAfterStepBehavior(parentElementMeasurements, eventContext);
          this.processIntraloopEvents(this.eventQueue);
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
    }
  }, {
    key: "handleParentElementAfterStepBehavior",
    value: function handleParentElementAfterStepBehavior(parentElementMeasurements, eventContext) {
      var _this5 = this;

      (0, _helpers.assertState)("running", this.ucrtState);

      for (var _i7 = 0, _Object$entries2 = Object.entries(parentElementMeasurements); _i7 < _Object$entries2.length; _i7++) {
        var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i7], 2),
            parentElementUid = _Object$entries2$_i[0],
            measurementMap = _Object$entries2$_i[1];

        var behavior = this.ucrtState.behaviorMgr.getBehavior(parentElementUid);

        if (!behavior) {
          throw new Error("invariant violated: behavior for element ".concat(parentElementUid, " was not found in behavior manager"));
        }

        var parentElement = this.elements[parentElementUid];

        if (!parentElement) {
          if (this.debug) console.debug("parent element ".concat(parentElementUid, " was not found in element map, is it a subelement?"));
          continue;
        }

        var remappedMeasurements = /* @__PURE__ */new Map();

        var _loop3 = function _loop3() {
          var terminalUid = _Object$keys5[_i8];
          var tuid = (0, _core.createTUID)([parentElementUid, terminalUid], _core.simulatorNodeDelimiter);

          var net = _this5.nets.find(function (n) {
            return n.terminals.has(tuid);
          });

          if (!net) return "continue";

          var _iterator8 = _createForOfIteratorHelper(net.connectedElements),
              _step8;

          try {
            var _loop4 = function _loop4() {
              var otherElementUid = _step8.value;
              if (otherElementUid === parentElementUid) return "continue";
              var measurements = measurementMap[otherElementUid];
              if (!measurements) return "continue";

              var otherTerminalUids = _toConsumableArray(net.terminals.keys()).filter(function (t) {
                return t.startsWith(otherElementUid);
              });

              var _iterator9 = _createForOfIteratorHelper(otherTerminalUids),
                  _step9;

              try {
                for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
                  var otherTerminalUid = _step9.value;
                  var measurement = measurements.get(otherTerminalUid.split(_core.simulatorNodeDelimiter).pop());

                  if (!measurement) {
                    if (_this5.debug) console.debug("no measurement for terminal ".concat(otherTerminalUid, " on element ").concat(otherElementUid));
                    continue;
                  }

                  remappedMeasurements.set(terminalUid, measurement);
                }
              } catch (err) {
                _iterator9.e(err);
              } finally {
                _iterator9.f();
              }
            };

            for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
              var _ret4 = _loop4();

              if (_ret4 === "continue") continue;
            }
          } catch (err) {
            _iterator8.e(err);
          } finally {
            _iterator8.f();
          }
        };

        for (var _i8 = 0, _Object$keys5 = Object.keys(parentElement.part_version_data_cache.terminals); _i8 < _Object$keys5.length; _i8++) {
          var _ret3 = _loop3();

          if (_ret3 === "continue") continue;
        }

        behavior.afterStepFinished(eventContext, remappedMeasurements);
      }
    }
  }, {
    key: "computeEndTimeSeconds",
    value: function computeEndTimeSeconds() {
      return this.timeStepSeconds * this.maxSteps;
    }
  }, {
    key: "destroyUcrtState",
    value: function destroyUcrtState() {
      clearTimeout(this.stepTimeout);
      this.stepTimeout = void 0;

      if (this.ucrtState.type === "idle" || this.ucrtState.type === "running" || this.ucrtState.type === "error") {
        this.ucrtState.behaviorMgr.clearAllBehaviors();
        this.ucrtState.simulator.clear();
        this.nets = [];
        this.elements = {};
        this.ucrtState = waitingForRuntimeData(this.ucrtState.spiceFactory, _objectSpread(_objectSpread({}, this.ucrtState.runtimeData), {}, {
          documentState: void 0
        }));
      }
    }
  }, {
    key: "processIntraloopEvents",
    value: function processIntraloopEvents(events) {
      var _a, _b, _c;

      var newEvents = [];
      var event = events.shift();

      while (event) {
        switch (event.type) {
          case "outputMetrics":
            (_a = this.eventEmitter) == null ? void 0 : _a.emit((0, _SimulationEventEmitter.getOutputMetricsEventKey)(event.elementUid), event.metrics);
            break;

          case "alterModel":
            if (this.ucrtState.type !== "running" && this.ucrtState.type !== "idle") break;
            var designator = this.ucrtState.elementUidToDesignatorMap.get(event.elementUid);
            if (!designator) throw new Error("invariant violated - element ".concat(event.elementUid, " has no designator in event handler"));
            var mappedModel = this.ucrtState.deviceToElementMap.get(designator);
            if (!mappedModel) throw new Error("invariant violated - element ".concat(event.elementUid, " has no mapped model in event handler"));
            var alteration = this.ucrtState.simulationModelMapper.mapAlteration(event, mappedModel);
            if (!alteration) break;
            var alterResult = this.ucrtState.simulator.alter(alteration);

            if (!alterResult.ok) {
              if (this.debug) console.error("failed to alter simulator: ".concat(alterResult.why));
              break;
            }

            break;

          case "changeSymbol":
            if (this.changeSymbolForElement === void 0) {
              newEvents.push(event);
              break;
            }

            this.changeSymbolForElement(event.elementUid, event.symbol);
            break;

          case "enqueueSnackbar":
            if (this.enqueueSnackbar === void 0) {
              if (this.debug) console.debug("enqueueSnackbar callback not registered, received event:", event);
              break;
            }

            this.enqueueSnackbar(event.message, event.options);
            break;

          case "userCodeError":
            (_b = this.eventEmitter) == null ? void 0 : _b.emit(_SimulationEventEmitter.SimulationEventKey.UserCodeError, event.error);
            break;

          case "userCodeRuntimeError":
            if (this.enqueueSnackbar === void 0) {
              if (this.debug) console.debug("enqueueSnackbar callback not registered, received event:", event);
            } else {
              this.enqueueSnackbar(event.message, event.options);
            }

            this.toErrorState(typeof event.message === "string" ? event.message : "User code runtime error");
            break;

          default:
            (0, _ngspiceSimulator.unreachable)(event);
        }

        event = events.shift();
      }

      events.unshift.apply(events, newEvents);

      if (this.ucrtState.type === "running") {
        (_c = this.eventEmitter) == null ? void 0 : _c.emit(_SimulationEventEmitter.SimulationEventKey.Time, this.ucrtState.simulator.getSimulationTime());
      }
    }
  }]);

  return UserCodeRuntime;
}();

exports.default = UserCodeRuntime;;
  expose(
    Object.keys(exports).reduce(function(r,k){
      if (k=='__esModule') return r;
      r[k] = exports[k];
      return r;
    },{})
  )